import * as React from 'react';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Breadcrumb } from 'ui/common/breadcrumb';
import { BreadcrumbValue } from 'ui/common/breadcrumb/breadcrumb-item';
import { optionTypes } from 'ui/common/select/constants';
import { SelectItem } from 'ui/common/select/types';

interface BreadcrumbContainerProps {
  breadcrumbStack: BreadcrumbValue[];
  categoryId: number;
  setCategoryId: (categoryId: number) => void;
  onLoadOptions: (options: object) => void;
  levelsNotAllowed: boolean;
  includeDisabled?: boolean;
}

const numberOfLevels = 2;

export function BreadcrumbContainer({
  breadcrumbStack, categoryId, setCategoryId, onLoadOptions, levelsNotAllowed, includeDisabled
}: BreadcrumbContainerProps) {

  const loadOptionsByParentId = (parentId: number) => {
    const categoryIdParam = categoryId && { categoryId: categoryId };

    onLoadOptions({
      parentId,
      levels: numberOfLevels,
      ...(categoryIdParam),
      includeDisabled
    });
  };

  const isHome = (value: number) => {
    return value === 0;
  };
  
  const onBreadcrumbItemClick = (item: SelectItem) => {
    const categoryIdParam = categoryId && { categoryId: categoryId };    
    const itemValue = Number(item.value);

    if (isHome(itemValue)) {
      if (item.type === optionTypes.CATEGORY_OPTION) { 
        setCategoryId(undefined);
      }
      else {
        onLoadOptions({
          ...(!levelsNotAllowed && { levels: numberOfLevels }),
          ...(categoryIdParam),
          ...(!!includeDisabled && { includeDisabled })
        });
      }
    } else {
      if (item.type === optionTypes.CATEGORY_OPTION) {
          itemValue === categoryId ?
            //the last item with categoryOption type needs to load options with parentId
            loadOptionsByParentId(undefined) 
          :
            setCategoryId(itemValue);
      } else {
        loadOptionsByParentId(itemValue);
      }
    }
  };
  
  return (breadcrumbStack?.length > 1 || isDefinedIncludingZero(categoryId))
    ? <Breadcrumb items={breadcrumbStack} onClickItem={onBreadcrumbItemClick} />
    : null;
}
